import { PaymentMethod } from 'modules/company/types';
import { isPaymentVerificationOfPayeeCompatible } from 'src/core/modules/verification-of-payee/isPaymentVerificationOfPayeeCompatible';

import { type UserScheduledPayments } from '../types';

export const isUserVerificationOfPayeeCompatible = (
  userScheduledPayments: UserScheduledPayments,
  companyCurrency: string,
): boolean => {
  const bankInfos = userScheduledPayments.user.bankInfo?.bankAddress?.info;

  return isPaymentVerificationOfPayeeCompatible({
    companyCurrency,
    targetCurrency: companyCurrency,
    targetCountry: userScheduledPayments.user.bankInfo?.accountCountry,
    iban: bankInfos && 'iban' in bankInfos ? bankInfos.iban : undefined,
    isWireTransferAvailable: userScheduledPayments.scheduledPayments.some(
      (scheduledPayment) =>
        scheduledPayment.availablePaymentMethods.includes(
          PaymentMethod.WireTransfer,
        ),
    ),
  });
};
